import React from 'react';
import Button from 'react-bootstrap/Button';
import { useUniqueKey } from '../../hooks/useUniqueKey';
import { TrustedHtmlString } from '../../models/globals';

interface IReadMoreHtml {
    btnClassName?: string;
    fullHtml: TrustedHtmlString;
    truncatedHtml: TrustedHtmlString | null;
    ariaLabelSuffix?: string;
}

type ReadMoreHtmlProps = React.HTMLAttributes<HTMLDivElement> & IReadMoreHtml;

const ReadMoreHtml: React.FC<ReadMoreHtmlProps> = ({
    btnClassName = '',
    fullHtml,
    truncatedHtml,
    ariaLabelSuffix,
    ...divProps
}) => {
    const [collapsed, setCollapsed] = React.useState(!!truncatedHtml);
    const uniqueKey = useUniqueKey(`read-${collapsed ? 'more' : 'less'}`);
    const readMoreLabelText = ariaLabelSuffix ? 'Read more ' + ariaLabelSuffix : 'Read more';
    const readLessLabelText = ariaLabelSuffix ? 'Read less ' + ariaLabelSuffix : 'Read less';
    const labelText = collapsed ? readMoreLabelText : readLessLabelText;

    return (
        <div {...divProps}>
            <div dangerouslySetInnerHTML={{ __html: collapsed && truncatedHtml ? truncatedHtml : fullHtml }} />
            {!!truncatedHtml && (
                <Button
                    className={`${btnClassName} px-0 text-decoration-none`.trim()}
                    key={uniqueKey} // So that the :hover state clears immediately when toggled
                    onClick={() => setCollapsed((c) => !c)}
                    variant="link"
                    aria-label={labelText}
                >
                    {collapsed ? 'Read more' : 'Read less'}
                </Button>
            )}
        </div>
    );
};

export { ReadMoreHtml, IReadMoreHtml };
